module.exports = __webpack_public_path__ + "img/Schweppes.1dd9bcd3.png";